<div class="position-relative" [formGroup]="formGroup">
  <app-review-phone-country-code-dropdown-input
    [formControlName]="countryCodeControlName"
    [countryDropdowns]="countryCodes" />
  <app-review-phone-country-code-number-input
    [formControlName]="phoneNumberControlName"
    [controlId]="controlId"
    [countryCode]="formGroup.controls[countryCodeControlName].value"
    [error]="error" />
</div>
